import axios from "axios";
import { jrNotifyEx } from "../bootstrap";

export const ErrorListMixin = {
    data() {
        return {
            submitted: 0,
            errorObject: null
        };
    },

    methods: {
        prepErrorList: function() {
            this.submitted = 0;
        },

        processResponse: function(response, success, failure) {
            this.errorObject = null;
            if (response && response.data) {
                if (response.data.success) {
                    this.submitted = 2;
                    if (success) {
                        success(response.data);
                    }
                } else {
                    this.errorObject = response.data;
                }
            } else {
                this.errorObject = { error: "Unexpected error. Please try again." };
            }

            if (this.errorObject) {
                this.submitted = 0;
                if (failure) {
                    failure(response);
                }
            }
        },

        postAndErrorCheck: async function(url, data, success, failure) {
            this.errorObject = null;
            this.submitted = 1;
            try {
                const response = await axios.post(url, data);
                this.processResponse(response, success, failure);
            } catch (e) {
                if (e && (!e.status || e.status != 422)) {
                    jrNotifyEx(e, e.response);
                }
                this.processResponse(e.response, success, failure);
            }
        }
    }
};
